import type { ItemType } from "types"

export const isItemAvailable = (item: ItemType): boolean =>
  item?.type !== "product" || item?.variant?.availability.status === "instock"
